export { default } from './FAQ';
export type { FaqProps } from './FAQ';
export type { FaqEntry } from './FAQ';
